export { startSegmentCollection, setSegmentBytesLimit } from './segmentCollection';
export { startDeflateWorker } from './startDeflateWorker';
export { SEGMENT_BYTES_LIMIT } from './segmentCollection';
//# sourceMappingURL=index.js.map